import { isKITProduct, type ProductData } from "~/domains/product/types/ProductData";
import { type OptionalPartFormData } from "~/features/addToCart/hooks/useAddToCartNew";

export const mapOptionalParts4Wishlist = (parentProduct?: ProductData, optionalParts?: Dict<OptionalPartFormData>) => {
  if (!isKITProduct(parentProduct) || !optionalParts) {
    return undefined;
  }
  return Object.entries(optionalParts)
    .filter(([productCode, item]) => item.selected)
    .map(([productCode, item]) => ({
      productCode,
      quantity: parentProduct.optionalParts.find((item) => item.product.code === productCode)?.quantity ?? 1,
    }));
};
